import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Navigate } from 'react-router-dom';

import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Landing from './Landing';
import Dashboard from './Dashboard';
import { collapse } from '../redux/sidebarSlice';
import { setActiveView } from '../redux/viewSlice';

import './App.scss';

function App() {
    const dispatch = useDispatch();

    const isLoggedIn = useSelector(state => state.auth.loggedIn);
    const activeView = useSelector(state => state.view.activeView);
    const { isCollapsed } = useSelector(state => state.sidebar);
    const isPhone = useMediaQuery({ maxDeviceWidth: 767 });

    useEffect(() => {
        if (!isLoggedIn) {
            dispatch(setActiveView(null));
        }
    }, [isLoggedIn, dispatch]);

    if (!isLoggedIn) {
        return <Navigate to="login" />;
    }

    return (
            <div
                className={clsx('d-flex align-items-stretch h-100 w-100', {
                    'flex-column': isPhone,
                })}
            >
                {isPhone ? <Topbar /> : <Sidebar />}

                {activeView === null ? (
                    <Landing isPhone={isPhone} />
                ) : (
                    <Dashboard isPhone={isPhone} />
                )}

                {!isPhone && (
                    <>
                        <div
                            id="overlay"
                            className={clsx(isCollapsed && 'disabled')}
                            onClick={() => dispatch(collapse())}
                        ></div>
                    </>
                )}
            </div>
    );
}

export default App;
